/**
 * @author vishwadeep.kapoor
 * @Date: 2020-11-20 16:53:05
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-11-20 18:39:13
 */

import React, { Fragment } from 'react';
import { Row, Col, Icon } from 'antd';
import { Link } from 'react-router-dom';
import { LandingContainer, SubTitle } from '../../../../components';
import endPoints from '../../../../config/endPoints';
import { constants } from '../../../../devUtils';

const StartUp = () => (
  <Fragment>
    <section className="section-solution">
      <Row align="middle" type="flex" justify="start" >
        <Col xs={24} sm={24} md={12} lg={12} xl={12}>
          <img
            src={endPoints.BUILT_EVERYONE_STARTUP.URL}
            alt={endPoints.BUILT_EVERYONE_STARTUP.ALT}
            className="width-100 img-grayscale"
          />
        </Col>
        <Col xs={24} sm={24} md={12} lg={12} xl={12} className="padding-l-5">
          <h2 className="font-18"><b>Startups</b></h2>
          <p>
            Startups have an advantage of being agile, ability to change processes, disrupt the industry<br />
            and deliver the best customer experience. We will be providing the right solution to be an<br />
            integral part of maintaining the company’s finances
          </p>
          <Row align="middle" type="flex" justify="start" className="padding-1">
            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
              <img
                src={endPoints.BUILT_EVERYONE_TEAM_ICON.URL}
                alt={endPoints.BUILT_EVERYONE_TEAM_ICON.ALT}
                className="width-8 icon"
              />
            </Col>
            <Col xs={24} sm={24} md={21} lg={21} xl={21}>
              <p className="nomargin">
                Save your team’s time by automating the tedious, manual work and let them<br />
                focus on productive activities.
              </p>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-1"></Col>
            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
              <img
                src={endPoints.BUILT_EVERYONE_CARD_ICON.URL}
                alt={endPoints.BUILT_EVERYONE_CARD_ICON.ALT}
                className="width-8 icon"
              />
            </Col>
            <Col xs={24} sm={24} md={21} lg={21} xl={21}>
              <p className="nomargin">
                Our financial management & analytics tool will help startups to take informed<br />
                financial decisions and aid in streamlining their financial operations.
              </p>
            </Col>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="padding-1"></Col>
            <Col xs={24} sm={24} md={3} lg={3} xl={3}>
              <img
                src={endPoints.BUILT_EVERYONE_FLOW_ICON.URL}
                alt={endPoints.BUILT_EVERYONE_FLOW_ICON.ALT}
                className="width-8 icon"
              />
            </Col>
            <Col xs={24} sm={24} md={21} lg={21} xl={21}>
              <p className="nomargin">
                Streamlining the cash flows in and out from the very first moment.
              </p>
            </Col>
          </Row>
        </Col>
      </Row>
    </section>
    <section className="padding-tb-3">
      <LandingContainer>
        <div className="text-center padding-tb-2">
          <SubTitle fontWeight="900" className="font-26">Uplift your employee motivation and Expense<br />management with Zaggle
          </SubTitle>
        </div>
        <Row align="middle" type="flex" gutter={16}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <h2>Boost the motivation</h2>
            <p>
              An ideal solution to reward employees and mark the unforgettable recognition for their achievements to boost motivation, foster a healthy work environment, and improve retention.
              <br /><br />
              Zaggle Edge has a variety of prepaid cards for customized employee benefits. These prepaid cards help in automation and systematic rewarding processes without any hassle.
            </p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <img
              src={endPoints.STARTUP_BOOST.URL}
              alt={endPoints.STARTUP_BOOST.ALT}
              className="width-100 img-grayscale"
            />
          </Col>
        </Row>
      </LandingContainer>
    </section>
    <section className="padding-tb-3">
      <LandingContainer>
        <Row align="middle" type="flex" gutter={16}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <img
              src={endPoints.STARTUP_GIVE.URL}
              alt={endPoints.STARTUP_GIVE.ALT}
              className="width-100 img-grayscale"
            />
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <h2>Give them all reasons to stay</h2>
            <p>
              Propel is an integrated platform for managing the engagement and retention programs for employees. It automates the employee recognition and rewards mechanism effortlessly.
              <br /><br />
              Propel is an easy and comprehensive Saas application for the start-up which can help them in the reduction of lots of manual work involved in employee engagement and recognition to retain the employee interest in the company.
            </p>
          </Col>
        </Row>
      </LandingContainer>
    </section>
    <section className="padding-tb-3">
      <LandingContainer>
        <Row align="middle" type="flex" gutter={16}>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <h2>Maintain transparency</h2>
            <p>
              Zaggle EMS is an exclusive start-up application that gives complete records of expenditure on one go.
              <br /><br />
              Zaggle EMS has set the employee expense management to new heights by bringing all employees and expenses on one platform giving centralized visibility and control over company-wide expenditure, anytime, across any device.
              <br /><br />
              It helps in cutting down the unauthorized spent which in turn benefits the start-ups and provides a clear record of all expenses in a simpler form.
            </p>
          </Col>
          <Col xs={24} sm={24} md={12} lg={12} xl={12}>
            <img
              src={endPoints.STARTUP_MAINTAIN.URL}
              alt={endPoints.STARTUP_MAINTAIN.ALT}
              className="width-100 img-grayscale"
            />
          </Col>
        </Row>
      </LandingContainer>
    </section>
    <section className="gray-greadient text-center padding-tb-5">
      <LandingContainer>
        <SubTitle fontWeight="900" className="font-26">
          See how Zaggle products can fit your needs
        </SubTitle>
        <Link to={constants.LINK_CONTACTUS} className="btn red-btn">CONNECT WITH EXPERT NOW<Icon type="right" /></Link>
      </LandingContainer>
    </section>
  </Fragment>
);

export default StartUp;



// WEBPACK FOOTER //
// client/containers/NewLanding/Solutions/StartUp/index.js